import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

import { BranchCreateForm as ABranchCreateForm } from "ui-components/index";

const BranchCreateForm = ({ onSuccess, baseCompanyId }) => {
  const navigate = useNavigate();
  const { companyId: companyIdParam } = useParams();
  const companyId = baseCompanyId ?? companyIdParam;

  const onSubmit = (modelFields) => ({
    ...modelFields,
    companyID: companyId,
  });
  const onSuccessForm = () => {
    toast.success(strings.successAdded);
    if (onSuccess) onSuccess();
    else navigate(`/companies/${companyId}/details`);
  };
  const onError = (_model, error) => toast.error(error);

  return (
    <div>
      <ABranchCreateForm
        overrides={{
          name: {
            label: (
              <span>
                {strings.fields.name}
                <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
              </span>
            ),
          },
          customId: {
            label: (
              <span>
                {strings.fields.id}
                <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
              </span>
            ),
          },
          abbreviation: {
            label: strings.fields.abbreviation,
          },
          address: {
            label: strings.fields.address,
          },
          phone: {
            label: strings.fields.phone,
          },
          country: {
            label: strings.fields.country,
          },
          city: {
            label: strings.fields.city,
          },
          description: {
            label: strings.fields.description,
          },
          ClearButton: {
            children: strings.clear,
          },
          SubmitButton: {
            children: strings.add,
          },
        }}
        onSubmit={onSubmit}
        onSuccess={onSuccessForm}
        onError={onError}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Sede",
    clear: "Restablecer",
    add: "Agregar",
    successAdded: "Sede agregada con éxito",
    fields: {
      id: "Identificador",
      name: "Nombre Sede",
      abbreviation: "Abreviatura",
      address: "Dirección",
      phone: "Teléfono",
      country: "País",
      city: "Ciudad",
      description: "Descripción",
    },
  },
});

export default BranchCreateForm;
